import {forwardRef} from 'react';

import {BaseAvatar} from '../base-avatar';

import type {UserAvatarProps} from '../../types';

import {getAvatarInitials} from './get-avatar-initials';

import styles from './styles.module.css';

export const UserAvatar = forwardRef<HTMLDivElement, UserAvatarProps>((props, ref) => {
    const {username = '', text = '', ...restProps} = props;

    const initials = getAvatarInitials(text, username);

    return (
        <BaseAvatar
            ref={ref}
            initials={initials}
            ariaLabel={username}
            alt={username}
            initialsClassName={styles.initialsColors}
            {...restProps}
        />
    );
});
